// Vanilla CSS for the bar primitives (ScoreBar, ProgressBar). Prefix: bar-.
// Aggregated into libraryStyles. "Playful Frost": rounded tracks with an inset
// shadow and glossy gradient fills (a top-edge highlight on the fill).
export const barStyles = `
  /* ScoreBar */
  .bar-score-row { display: flex; align-items: center; gap: 0.5rem; }
  .bar-score-track {
    flex: 1 1 0%;
    background-color: var(--catchup-gray-50);
    border-radius: var(--rad-catchup-full);
    overflow: hidden;
    box-shadow: inset 0 1px 2px rgba(15, 72, 89, 0.1);
  }
  .bar-h-sm { height: 0.75rem; }
  .bar-h-md { height: 1.25rem; }
  .bar-h-lg { height: 1.75rem; }
  .bar-score-fill {
    position: relative;
    height: 100%;
    border-radius: var(--rad-catchup-full);
    transition: width var(--duration-slow) var(--ease-glass), background-color var(--duration-base) var(--ease-standard);
  }
  .bar-score-fill::after {
    content: "";
    position: absolute;
    inset: 0 0 auto 0;
    height: 50%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.45), transparent);
    border-radius: inherit;
    pointer-events: none;
  }
  .bar-fill-green { background-image: linear-gradient(to right, var(--catchup-green), var(--catchup-hover-green)); }
  .bar-fill-orange { background-image: linear-gradient(to right, #ffa98f, var(--catchup-orange)); }
  .bar-fill-red { background-image: linear-gradient(to right, #ff9b9b, var(--catchup-red)); }
  .bar-score-pct { min-width: 35px; font-weight: var(--font-weight-semi); text-align: right; }
  .bar-txt-green { color: var(--catchup-hover-green); }
  .bar-txt-orange { color: var(--catchup-orange); }
  .bar-txt-red { color: var(--catchup-red); }

  /* ProgressBar (timed) */
  .bar-prog { position: relative; width: 100%; }
  .bar-prog-title { position: absolute; top: 0.5rem; left: 1.5rem; }
  .bar-prog-title-text { font-size: var(--fs-xl); }
  .bar-prog-time { position: absolute; top: 0.5rem; right: 1.5rem; }
  .bar-prog-time-inner { display: flex; flex-direction: row; font-size: var(--fs-xl); }
  .bar-prog-digit { margin-left: 0.25rem; margin-right: 0.25rem; }
  .bar-prog-frame {
    border: 1px solid;
    border-radius: var(--rad-catchup-full);
    overflow: hidden;
    box-shadow: inset 0 1px 2px rgba(15, 72, 89, 0.1);
  }
  .bar-prog-border-default { border-color: var(--catchup-red); }
  .bar-prog-track { width: 100%; }
  .bar-prog-fill {
    position: relative;
    border-radius: var(--rad-catchup-full);
    transition: width var(--duration-slow) var(--ease-glass);
  }
  .bar-prog-fill::after {
    content: "";
    position: absolute;
    inset: 0 0 auto 0;
    height: 50%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.4), transparent);
    border-radius: inherit;
    pointer-events: none;
  }
  .bar-prog-fill-default { background-color: var(--catchup-red); }
  .bar-prog-h-default { height: var(--h-catchup-quicktivity); }
`;
